import React from 'react';

/**
 * Error Boundary component to catch React rendering errors
 * Displays error details on screen for debugging in kiosk/device mode
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          backgroundColor: '#1a1a2e',
          color: '#eee',
          padding: '20px',
          minHeight: '100vh',
          fontFamily: 'monospace',
          fontSize: '14px',
          overflow: 'auto'
        }}>
          <h1 style={{ color: '#ff6b6b', marginBottom: '20px' }}>
            Application Error
          </h1>
          <div style={{
            backgroundColor: '#16213e',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '15px'
          }}>
            <h2 style={{ color: '#feca57', marginTop: 0 }}>Error Message:</h2>
            <pre style={{ color: '#ff6b6b', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {this.state.error && this.state.error.toString()}
            </pre>
          </div>
          <div style={{
            backgroundColor: '#16213e',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '15px'
          }}>
            <h2 style={{ color: '#feca57', marginTop: 0 }}>Component Stack:</h2>
            <pre style={{ color: '#54a0ff', whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '12px' }}>
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </pre>
          </div>
          <div style={{
            backgroundColor: '#16213e',
            padding: '15px',
            borderRadius: '8px'
          }}>
            <h2 style={{ color: '#feca57', marginTop: 0 }}>Debug Info:</h2>
            <pre style={{ color: '#54a0ff', fontSize: '12px' }}>
              Platform: {window.Capacitor ? 'Capacitor' : 'Web'}{'\n'}
              Hostname: {window.location.hostname}{'\n'}
              Hash: {window.location.hash}{'\n'}
              Capacitor Platform: {window.Capacitor?.getPlatform?.() || 'N/A'}{'\n'}
              User Agent: {navigator.userAgent}
            </pre>
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#00cec9',
              border: 'none',
              borderRadius: '5px',
              color: '#1a1a2e',
              fontSize: '16px',
              cursor: 'pointer'
            }}
          >
            Reload Application
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
